import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { LoanChecklist } from '../loans/types';
import { checklistMockData } from '../utils/checklist.mock';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';

interface GlobalChecklistResponse {
  checklistRules: LoanChecklist[];
  success: boolean;
}

const _mockData = checklistMockData('Global ');

const getGlobalChecklist: QueryFunction<
  LoanChecklist[],
  ['/global/checklist-rules']
> = async () => {
  if (isMockServices()) return await mock(_mockData);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<GlobalChecklistResponse>(
    '/checklist-rules',
    {
      method: 'GET',
    },
  );
  if (response.data) return response.data.checklistRules;
  throw new Error('Failed to fetch global checklist');
};

export default getGlobalChecklist;
